import React, { useState } from "react";
import ShareIcon from "../../../../images/SideBar/Share";
import ViewFileImg from "../../../../images/SideBar/viewFile";
import ClientIcon from "../../../../images/SideBar/Client";
import EditImg from "../../../../images/SideBar/Edit";
import CommonDataGrid from "../../../../components/CommonDataGrid";
import useMyLead from "./useMyLead";
import { Column } from "../../../../components/CommonDataGrid/props";
import EmailIcon from "../../../../images/SideBar/EmailIcon";
import { leadStyes, Roles } from "../../../../util/constant";
import ApiService from "../../../../service/ApiService";
import toast from "react-hot-toast";
import { apiPaths } from "../../../../service/apiPaths";

interface Lead {
  _id: string;
  name: string;
  leadStatus: string;
  email?: string;
  phone?: string;
}

const MyLeads = ({ leads }: { leads: Lead[] | undefined }) => {
  const { leadData, page, totalPage, setPage, setSearch } =
    useMyLead();

  const Role = localStorage.getItem("role");
  const currentSubRole = localStorage.getItem("subRole");
  const contactedLeads = leads
    ? leads.filter((lead: Lead) => lead.leadStatus === "Contacted")
    : [];
const [loading, setLoading] = useState<boolean>(false)
  const [selectedLeadForReminder, setSelectedLeadForReminder] = useState<
    string | null
  >(null);
  const [isReminderPopupOpen, setIsReminderPopupOpen] = useState(false);

  const handleConfirmLeadStatusUp = async (
    id: any,
    status: any,
    reminderDate?: Date
  ) => {
    setLoading(true);
    const updateData = {
      leadStatus: status,
      ...(reminderDate && { reminderDate: reminderDate }),
      // Clear reminder date if status is changed from "Reminder" to something else
      ...(id.leadStatus === "Reminder" && status !== "Reminder" && { reminderDate: null }),
    };
    try {
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.leadStatus}${id._id}`,
        data: updateData,
      });
      toast.success("Lead status updated successfully");
      // handleDateFilter(today, today);
    } catch (error: any) {
      console.error("Error updating Lead status:", error);
      toast.error(
        error?.response?.data?.message || "Error updating Lead status"
      );
    } finally {
      setLoading(false);
    }
  };
  const handleSelectStatus = (e: any, id: any) => {
    const status = e.target.value;
    const reminderDate = id.reminderDate;
    handleConfirmLeadStatusUp(id, status, reminderDate);
  };

  const handleStatusChange = (e: any, params: any) => {
    const status = e.target.value;
    if (status === "Reminder") {
      setSelectedLeadForReminder(params.row._id);
      setIsReminderPopupOpen(true);
    } else {
      handleSelectStatus(e, params.row);
    }
  };

  const columns: Column[] = [
    {
      field: "userId",
      headerName: "creator Name",
      width: 50,
      renderCell: (params: any) => (
        <div className="flex items-center gap-1 w-2">
          {params.row.isEmailSent === true && (
            <div
              className={`flex items-center group relative ${
                params.row.isEmailSentStatus ? "text-green-600" : "text-red-600"
              }`}
            >
              <EmailIcon />
              <span className="absolute left-7 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                {params.row.isEmailSentStatus
                  ? params.row.messageSent
                  : params.row.error}
              </span>
            </div>
          )}
          <p>{params.value?.name}</p>
        </div>
      ),
    },
    {
      field: "linkedin",
      headerName: "Lead Name",
      renderCell: (params: any) => (
        <a
          className="text-blue-500 border-b-2 border-blue-500 cursor-pointer"
          href={params.value}
          target="_blank"
          rel="noopener noreferrer"
        >
          {params.row.name}
        </a>
      ),
      width: 50,
      align: "center",
    },
    {
      field: "userId",
      headerName: "Attend BY",
      renderCell: (params: any) => {
        // If admin, show dropdown

        <p className="px-3 py-1  text-black rounded-md  text-sm">
          {params.row.name}
        </p>;

        // If already assigned, show the name
        if (params.row.connectedId) {
          return (
            <p className="text-green-600 font-medium bg-green-100 h-full w-full flex items-center justify-center">
              {params.row.connectedId.name}
            </p>
          );
        }

        // Otherwise, show Contact button
        return (
          <button
            onClick={() => {
              // TODO: Implement handleContactLead function
              console.log("Contact lead:", params.row._id);
            }}
            className="px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm disabled:bg-gray-400"
            disabled={loading}
          >
            Contact
          </button>
        );
      },
      width: 50,
      align: "center",
    },
    {
      field: "",
      headerName: "Add to Sequences",
      renderCell: (params: any) => (
        <>
          {(Role === Roles.admin || currentSubRole === Roles.bde_manager) &&
          params.row.isSequence === true ? (
            <p className="text-green-600 font-medium h-full w-full flex items-center justify-center">
              Add Sequence
            </p>
          ) : (
            <p className="text-green-600 font-medium  h-full w-full flex items-center justify-center">
              Not Applied
            </p>
          )}
        </>
      ),
      width: 50,
      align: "center",
    },
    {
      field: "description",
      headerName: "Description",
      width: 50,
      align: "center",
    },
    {
      field: "leadStatus",
      renderCell: (params: any) => (
        <>
          <div
            className={`${leadStyes[params.value] || "bg-gray-200 "} min-w-24`}
          >
            <select
              defaultValue={params.value}
              onChange={(event) => handleStatusChange(event, params)}
              className="appearance-none  bg-transparent outline-none w-full cursor-pointer font-semibold"
            >
              <option value="New">New</option>
              <option value="Send For Review">Send For Review</option>
              <option value="Approved">Approved</option>
              <option value="Skip">Skip</option>
              <option value="Rejected">Rejected</option>
              <option value="Contacted">Connected</option>
              <option value="Converted">Converted</option>
              <option value="Lost">Lost</option>
              <option value="Duplicate">Duplicate</option>
              <option value="Not Interested">Not Interested</option>
              <option value="On Hold">On Hold</option>
              <option value="Reminder">Reminder</option>
            </select>
          </div>
        </>
      ),
      headerName: "lead Status",
      width: 50,
      align: "center",
    },
    {
      field: "services",
      headerName: "Services",
      width: 150,
      renderCell: (params: any) => {
        const selectedService =
          (params.row.services?.type && params.row.serviceActive) ||
          params.row.services?.type;

        return (
          <div className=" text-black rounded-md p-1 min-w-24">
            <p className="appearance-none bg-transparent outline-none w-full cursor-pointer font-medium">
              {params.row.services?.type}
            </p>
          </div>
        );
      },
    },

    {
      field: "lookingFor",
      headerName: "Looking For",
      renderCell: (params: any) => <p>{params.value}</p>,
      width: 50,
      align: "center",
    },
    // {
    //   field: "Actions",
    //   headerName: "Actions",
    //   width: 50,
    //   align: "center",
    //   renderCell: (params: any) => (
    //     <div className="flex space-x-2 justify-center">
    //       <button
    //         onClick={() => handleEdit(params.row._id)}
    //         className="text-fontColor hover:text-primary-2"
    //       >
    //         <EditImg />
    //       </button>
    //       {Role === Roles.admin && (
    //         <button
    //           onClick={() => handleStatusUp(params.row._id)}
    //           className="text-blue-500 hover:text-blue-700"
    //         >
    //           <ClientIcon />
    //         </button>
    //       )}
    //       <button
    //         onClick={() => navigate(`/lead/${params.row._id}`)}
    //         className="text-blue-600 hover:text-blue-800 relative"
    //       >
    //         <span className="text-xs absolute bg-red-500 p-2 -right-1 text-white rounded-full w-3 h-3 flex items-center justify-center">
    //           {params.row.messageCount}
    //         </span>
    //         <ViewFileImg />
    //       </button>
    //       <button
    //         onClick={() => {
    //           const leadUrl = `https://task.blisslers.com/lead/${params.row._id}`;
    //           copy(leadUrl);
    //           toast.success("Lead URL copied to clipboard!");
    //         }}
    //         className="text-green-600 hover:text-green-800"
    //       >
    //         <ShareIcon />
    //       </button>
    //     </div>
    //   ),
    // },
  ];

  return (
    <div className="p-6">
      <h2 className="font-semibold p-2 ">My Leads</h2>
      {contactedLeads.length === 0 ? (
        <p>No contacted leads yet.</p>
      ) : (
        <CommonDataGrid
          tableName="Lead"
          rows={leadData}
          columns={columns}
          getRowId={(row) => row._id}
          showConfirmation={false}
          confirmationMessage=""
          onCancelDelete={() => {}}
          onConfirmDelete={() => {}}
          loading={loading}
          addButton
          setSearchBar={setSearch}
          setCurrentPage={setPage}
          currentPage={page}
          totalPages={totalPage}
          downloadCSVFilter={false}
        />
      )}
    </div>
  );
};

export default MyLeads;
